import { Formik } from "formik";
import SearchField from "../../../forms/search-field";
import { useDispatch } from "react-redux";
import { purchaseProductListAction } from "../../../../redux/actions/purchase-action";
import DynamicTransactionTable from "../../../tables/dynamic-transaction-table";
import AddButton from "../../../buttons/button";
import { useNavigate } from "react-router-dom";
import { useCallback, useEffect, useMemo, useState } from "react";
const ViewVendorCatalouge = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [tableBodyData, setTableBodyData] = useState([]);
  const [reload, setReload] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [dataCount, setDataCount] = useState(200);
    const dummyVoidAction = useCallback(
        (payload, onSuccess, onError) =>
          async () => {
            try {
              setLoading(true);
              const deleteId = payload?.bc_id ?? payload?.cmr_id ?? payload?.id;
              if (deleteId) {
                setTableBodyData((prev) => prev.filter((r) => r.id !== deleteId));
              }
              setLoading(false);
              onSuccess?.({ message: "Deleted" });
            } catch (e) {
              setLoading(false);
              onError?.(e);
            }
          },
        []
      );
  const initialValues = {
    system_item_code: null,
    system_item_name: null,
  };
  const [filterData, setFilterData] = useState({
    sort_by: "",
    sort_order: "",
    selectColumn: "",
    from: "",
    to: "",
    inputValue: "",
    orderStatus: "",
  });
  useEffect(()=>{
      console.log(filterData.selectColumn);
      console.log(filterData.inputValue);
    },[reload, currentPage, pageSize, filterData])
    const paginationProps = {
      pageSize: pageSize,
      setPageSize: setPageSize,
      dataCount: dataCount,
      setCurrentPage: setCurrentPage,
      currentPage: currentPage,
};
  const loadSystemOptions = (inputValue, field) =>
    new Promise((resolve) => {
      const onSuccess = (data) => {
        const rows = data?.data || [];
        resolve(
          rows.map((it) => ({
            value: it.item_id,
            label: field === "item_code" ? it.item_code : it.item_name,
            raw: it,
          }))
        );
      };

      const onError = () => resolve([]);

      if (inputValue?.length > 0) {
        dispatch(
          purchaseProductListAction(
            { field, value: inputValue },
            onSuccess,
            onError
          )
        );
      } else {
        resolve([]);
      }
    });
    const heading = useMemo(
        () => [
          { label: "Vendor Code", value: "vendor_code", minWidth: 120,column: true,display: true,enabled: true, },
          { label: "Vendor Name", value: "vendor_name", minWidth: 160,column: true,display: true,enabled: true, },
          { label: "No.Of items", value: "no_of_items", minWidth: 120,column: true,display: true,enabled: true, },
          { label: "Created By", value: "created_by", minWidth: 140,column: true,display: true,enabled: true, },
          { label: "Created On", value: "created_on", minWidth: 170,column: true,display: true,enabled: true, },
          { label: "Updated By", value: "updated_by", minWidth: 140,column: true,display: true,enabled: true, },
          { label: "Updated On", value: "updated_on", minWidth: 170,column: true,display: true,enabled: true, }
        ],
        []
      );
  return (
    <div>
      <Formik initialValues={initialValues} onSubmit={() => {}}>
        {({ setFieldValue }) => (
          <div className="flex flex-row justify-around gap-4">
            <div className="min-w-0 w-[220px]">
              <SearchField
                type="text"
                label="System Item Code"
                name="system_item_code"
                placeholder="Select System Code"
                showCreateCTA={false}
                loadOptions={(e) => loadSystemOptions(e, "item_code")}
                onChange={(opt, actionMeta) => {
                  if (actionMeta?.action === "clear") {
                    setFieldValue("system_item_code", null);
                    setFieldValue("system_item_name", null);
                    return;
                  }
                  if (!opt?.raw) return;

                  setFieldValue("system_item_code", {
                    value: opt.raw.item_id,
                    label: opt.raw.item_code,
                  });
                  setFieldValue("system_item_name", {
                    value: opt.raw.item_id,
                    label: opt.raw.item_name,
                  });
                }}
              />
            </div>

            {/* System Item Name */}
            <div className="min-w-0 w-[260px]">
              <SearchField
                type="text"
                label="System Item Name"
                name="system_item_name"
                placeholder="Select System Name"
                showCreateCTA={false}
                loadOptions={(e) => loadSystemOptions(e, "item_name")}
                onChange={(opt, actionMeta) => {
                  if (actionMeta?.action === "clear") {
                    setFieldValue("system_item_code", null);
                    setFieldValue("system_item_name", null);
                    return;
                  }
                  if (!opt?.raw) return;

                  setFieldValue("system_item_name", {
                    value: opt.raw.item_id,
                    label: opt.raw.item_name,
                  });
                  setFieldValue("system_item_code", {
                    value: opt.raw.item_id,
                    label: opt.raw.item_code,
                  });
                }}
              />
            </div>
            
            <div className="min-w-0 w-[220px]">
              <SearchField
                type="text"
                label="System Item Code"
                name="system_item_code"
                placeholder="Select System Code"
                showCreateCTA={false}
                loadOptions={(e) => loadSystemOptions(e, "item_code")}
                onChange={(opt, actionMeta) => {
                  if (actionMeta?.action === "clear") {
                    setFieldValue("system_item_code", null);
                    setFieldValue("system_item_name", null);
                    return;
                  }
                  if (!opt?.raw) return;

                  setFieldValue("system_item_code", {
                    value: opt.raw.item_id,
                    label: opt.raw.item_code,
                  });
                  setFieldValue("system_item_name", {
                    value: opt.raw.item_id,
                    label: opt.raw.item_name,
                  });
                }}
              />
            </div>

            {/* System Item Name */}
            <div className="min-w-0 w-[260px]">
              <SearchField
                type="text"
                label="System Item Name"
                name="system_item_name"
                placeholder="Select System Name"
                showCreateCTA={false}
                loadOptions={(e) => loadSystemOptions(e, "item_name")}
                onChange={(opt, actionMeta) => {
                  if (actionMeta?.action === "clear") {
                    setFieldValue("system_item_code", null);
                    setFieldValue("system_item_name", null);
                    return;
                  }
                  if (!opt?.raw) return;

                  setFieldValue("system_item_name", {
                    value: opt.raw.item_id,
                    label: opt.raw.item_name,
                  });
                  setFieldValue("system_item_code", {
                    value: opt.raw.item_id,
                    label: opt.raw.item_code,
                  });
                }}
              />
            </div>

          </div>
        )}
      </Formik>
        <DynamicTransactionTable
            transaction="Business Catalogue"
            transaction_type="bussiness_catalogue"
            module={"bussiness-catalouge-setup"}
            path="bussiness-catalouge"
            filterSec={false}
            tableHeading={heading}
            tableBodyData={tableBodyData}
            paginationProps={paginationProps}
            filterData={filterData}
            setFilterData={setFilterData}
            placeholder="Search (/)"
            showFilter={false}
            filter={false}
            list={false}
            menu={true}
            is_checkbox_req={false}
            setLoading={setLoading}
            reload={reload}
            setReload={setReload}
            deleteAction={dummyVoidAction}
            transactionKey="bc"
            actionsPermissions={{
              edit: ["draft"],
              delete: ["draft"],
              send: [],
              print: [],
              clone: [],
            }}
            onClickItemFn={(id) => console.log("row click", id)}
            onclkFn={() => console.log("new")}
            cloneFn={(id) => console.log("clone", id)}
            date={false}
            showClear={false}
            addNew={true}  
            showFilterArrows={false}
          />
    </div>
  );
};

export default ViewVendorCatalouge;
